import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="custom-dropdown"
export default class extends Controller {
  static targets = [ 'button', 'hiddenId' ]
  static values = {
    blankable: Boolean,
    autoSubmit: Boolean
  }

  connect() {
  }

  select(event) {
    event.preventDefault()
    this.hiddenIdTarget.value = event.currentTarget.dataset.id || null
    this.buttonTarget.innerHTML = event.currentTarget.innerHTML
    if (this.autoSubmitValue) {
      const form = event.currentTarget.closest('form');
      form.requestSubmit();
    }
  }
}
